
const LigneLivraisonCollection = function(element) {
    this.element = $(element);
    this.form    = this.element.closest('form');
    this.tbody   = this.element.find('table tbody');
    this.tfoot   = this.element.find('table tfoot');

    /// Bouton d'ajout de ligne
    this.element.on('before-load.modal', '[data-add-stock]', (event, requestData) => {
        this.setStockData(requestData);
    });
    this.element.on('modal-shown.modal', '[data-add-stock]', (event) => {
        const modal = event.modal;
        const table = event.element.find('table');

        // Add the line on tr click (except on split link)
        table.on('click', 'tbody tr', event => {
            const target = $(event.target);
            const link = target.closest('a');

            if (!link.length) {
                const tr = $(event.currentTarget);
                const index = parseInt(tr.attr('data-index'));
                const data = tr.closest('table').bootstrapTable('getData')[index];

                let row = this.initRow();
                this.updateRow(row, data);

                row.find('[name$="\[parentStockLigne\]"]').val(data.stockLigne.id);

                modal.hide();
            }
        });

        // Add stock from split action
        table.on('form-success.modal', 'a', (event, response) => {
            if (response.stock) {
                let row = this.initRow();
                this.updateRow(row, response.stock);

                row.find('[name$="\[parentStockLigne\]"]').val(response.stock.stockLigne.id);

                modal.hide();
            }
        });
    });

    /// Suppression
    this.tbody.on('click', '[data-delete]', event => {
        $(event.currentTarget).closest('tr').remove();

        this.updateTotalFooter();
    });

    /// Mise à jour donnée dans le tableau
    this.tbody.on('keyup change', 'input', event => {
        this.updateTotalRow($(event.currentTarget).closest('tr'));
    });

    this.tbody.on('ajax-query.select2', 'select[name$="\[calibre\]"]', (event, query) => {
        const target = $(event.currentTarget);
        const tr = target.closest('tr');

        query.famille = tr.find('[name$="\[famille\]"]').val();
        query.origine = tr.find('[name$="\[origine\]"]').val();
    });
    //
    // this.tbody.on('ajax-response.select2', 'select[name$="\[calibre\]"]', (event, response) => {
    //     console.log(response);
    // });
};

$.extend(LigneLivraisonCollection.prototype, {
    setStockData: function(requestData) {
        let exclude = [];
        this.tbody.find('tr input[name$="\[parentStockLigne\]"]').each(function() {
            let stock = $(this).val();
            if (stock) {
                exclude.push(stock);
            }
        });

        requestData.exclude = exclude;
    },

    initRow: function() {
        let prototype = this.element.attr('data-prototype'),
            name = parseInt(this.element.attr('data-next-name'));

        prototype = prototype.replace(/__name__/g, name);

        this.element.attr('data-next-name', name + 1);

        return $(prototype).appendTo(this.tbody);
    },

    updateRow: function(row, data) {
        row.attr('data-ligne-kgs', data.isKGS ? '1' : '0');

        row.find('[name$="\[famille\]"]').val(data.famille.id);
        row.find('[data-famille]').text(data.famille.designation);

        row.find('[name$="\[origine\]"]').val(data.origine ? data.origine.id : '');
        row.find('[data-origine]').text(data.origine ? data.origine.designation : '-');

        const calibre = new Option(data.calibre.designation, data.calibre.id, true, true);
        row.find('[name$="\[calibre\]"]').append(calibre).trigger('change');

        row.find('[name$="\[variete\]"]').val(data.variete ? data.variete.id : '');
        row.find('[data-variete]').text(data.variete ? data.variete.designation : '-');

        row.find('[name$="\[qualite\]"]').val(data.qualite ? data.qualite.id : '');
        row.find('[data-qualite]').text(data.qualite ? data.qualite.designation : '-');

        row.find('[name$="\[fournisseur\]"]').val(data.fournisseur.id);

        row.find('[name$="\[quantite\]"]').formatFloat(data.quantiteDisponible);
        row.find('[name$="\[quantiteUnitaire\]"]').formatFloat(data.quantiteDisponibleUnitaire);

        row.find('[name$="\[uniteVente\]"]').val(data.uniteVente);
        row.find('[data-unite-vente]').text(data.uniteVente);

        // row.find('[name$="\[prix\]"]').formatMoney(data.prix / 100);
        // row.find('[name$="\[prixUnitaire\]"]').formatMoney(data.prixUnitaire / 100);

        row.find('[name$="\[tauxTVA\]"]').val(data.tauxTVA);

        row.find('[data-fournisseur]').text(data.fournisseur ? data.fournisseur.labelTiers : '-');

        this.updateTotalRow(row);
    },

    updateTotalRow: function(row) {
        let quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').parseFloat(),
            prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseMoney(),
            totalHT = prixUnitaire * quantiteUnitaire;

        row.find('[name$="\[totalHT\]"]').formatMoney(totalHT);

        // Refresh champs KGS
        let quantite = row.find('[name$="\[quantite\]"]').parseFloat(),
            prix = Math.ceil(totalHT * 100. / quantite) / 100.;

        if (!isNaN(prix)) {
            row.find('[name$="\[prix\]"]').formatMoney(prix);
        }

        // Refresh quantite KGS if line is KGS
        if (row.attr('data-ligne-kgs') === '1') {
            row.find('[name$="\[quantite\]"]').formatFloat(quantiteUnitaire);
            row.find('[name$="\[prix\]"]').val(prixUnitaire);
        }

        this.updateTotalFooter();
    },

    updateTotalFooter: function() {
        let totalHT = 0;
        let totalQuantite = 0;

        this.tbody.find('[name$="\[totalHT\]"]').each(function() {
            totalHT += $(this).parseMoney();
        });
        this.tbody.find('[name$="\[quantite\]"]').each(function() {
            totalQuantite += $(this).parseFloat();
        });

        this.tfoot.find('input[name=totalHT]').formatMoney(totalHT);
        this.tfoot.find('input[name=totalQuantite]').formatFloat(totalQuantite);
    }
});

const ligneLivraisonCollection = () => {
    const selector = 'div[data-ligne-livraison-collection]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new LigneLivraisonCollection(this);
    });
};

export { ligneLivraisonCollection }


// WEBPACK FOOTER //
// ./js/form/ligneLivraisonCollection.js